import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=4844448a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4844448a')) {
      api.createRecord('4844448a', component.options)
    } else {
      api.reload('4844448a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=4844448a&", function () {
      api.rerender('4844448a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4xZMY1aiN6FwV/JS/comp/IncreaseNumber.vue"
export default component.exports